export const FM = 0.54; // Factor de conversión de litros a kilogramos para gas LP

export const processNotes = (data) =>
  data.map((note) => {
    let allProductsQuantity = 0;
    let allProductsName = "";
    let allProductMeasureUnit = "";
    let allProductsObj = {};
    let detailsWithNoteId = note.details.map((detail) => {
      if (!allProductsObj[(detail?.name)])
        allProductsObj[(detail?.name)] = detail?.quantity;
      else
        allProductsObj[(detail?.name)] =
          allProductsObj[(detail?.name)] + detail?.quantity;

      allProductsQuantity = allProductsQuantity + detail?.quantity;
      if (!allProductsName) allProductsName = detail?.name;
      else if (allProductsName !== detail?.name)
        allProductsName = "MULTI-PRODUCTO";

      if (!allProductMeasureUnit) allProductMeasureUnit = detail?.measureUnit;
      else if (allProductMeasureUnit !== detail?.measureUnit)
        allProductMeasureUnit = "PRODUCTOS";

      return {
        ...detail,
        idNote: note.id,
      };
    });
    return {
      ...note,
      allProductsQuantity,
      allProductsName,
      allProductMeasureUnit:
        allProductMeasureUnit === "CILINDRO" && allProductsQuantity > 1
          ? "CILINDROS"
          : allProductMeasureUnit,
      allProductsObj,
      details: detailsWithNoteId,
    };
  });

export const setSettlement = (state, payload) => {
  let totalValidateNotes = 0;
  let blackListFolio = [];
  const isPortable = payload.unit.type.toLowerCase().includes("portatil");
  const isSettlementAvailable =
    payload.settlementStatus === "SAVED" ||
    payload.settlementStatus === "CONFIRMED";
  const {
    routes: { start, end },
    kgBulk,
  } = payload;
  let totalCalc = 0;

  if (isPortable) {
    const endCil10 = end?.endowments?.cil10 || 0;
    const endCil20 = end?.endowments?.cil20 || 0;
    const endCil30 = end?.endowments?.cil30 || 0;
    const endCil45 = end?.endowments?.cil45 || 0;

    const startCil10 = start?.endowments?.cil10 || 0;
    const startCil20 = start?.endowments?.cil20 || 0;
    const startCil30 = start?.endowments?.cil30 || 0;
    const startCil45 = start?.endowments?.cil45 || 0;

    let c10 = (startCil10 - endCil10) * 10;
    let c20 = (startCil20 - endCil20) * 20;
    let c30 = (startCil30 - endCil30) * 30;
    let c45 = (startCil45 - endCil45) * 45;
    totalCalc = c10 + c20 + c30 + c45 + (kgBulk || 0);
  } else {
    totalCalc =
      (end?.endowments?.flowmeter || 0) - (start?.endowments?.flowmeter || 0);
  }

  let isMultiProduct = false;
  const notes = payload.notes.map((note, idx) => {
    const types = note.details.map((detail) => detail.name);
    const removeElements = [...new Set(types)];
    isMultiProduct = removeElements.length > 1;
    const quantity = note.details.reduce((acc, curr) => acc + curr.quantity, 0);
    blackListFolio.push(note.folio?.toString());

    const nDetails = note.details.map((detail) => {
      return {
        ...detail,
        capacity:
          state.products.find((pr) => pr.id === detail.idProduct)?.capacity ||
          0,
      };
    });

    const fPayment = state.payments.find((py) => py.id === note.idPayment);
    return {
      ...note,
      details: nDetails,
      name: isMultiProduct ? "MULTI-PRODUCTO" : removeElements[0],
      idAccount: note.customer?.account.id,
      accountName: note.customer?.account.name,
      accountCode: note.customer?.account.code,
      quantity,
      discount: note.details.reduce(
        (acc, curr) => acc + (curr.discount || 0),
        0,
      ),
      type: fPayment?.method || "",
      methodPayment: fPayment?.name || "",
      position: idx + 1,
      deleted: false,
      deletedCauseId: null,
      isNew: false,
      skip: false,
    };
  });

  const totalDiscountNotes = notes.reduce(
    (acc, curr) => acc + (curr.discount || 0),
    0,
  );

  const preciseSum = (a, b) => {
    return parseFloat((a + b).toFixed(2));
  };

  const totals = notes.reduce(
    (acc, curr) => {
      const payment = state.payments.find((py) => py.id === curr.idPayment);
      const paymentType = payment?.method?.toLowerCase();

      if (paymentType === "credito") {
        acc.totalCreditAmount = preciseSum(
          acc.totalCreditAmount,
          curr.total || 0,
        );
      } else if (paymentType === "contado") {
        acc.totalCashAmount = preciseSum(acc.totalCashAmount, curr.total || 0);
      }

      return acc;
    },
    {
      totalCreditAmount: 0,
      totalCashAmount: 0,
    },
  );

  totals.totalCreditAmount = parseFloat(totals.totalCreditAmount.toFixed(2));
  totals.totalCashAmount = parseFloat(totals.totalCashAmount.toFixed(2));

  const newPayload = {
    ...payload,
    notes: notes,
    totalValidateNotes: totalValidateNotes || 0,
    totalReport: parseFloat(totalCalc?.toFixed(2)) || 0,
    creditAmount: isSettlementAvailable
      ? payload.creditAmount
      : totals.totalCreditAmount,
    cashAmount: isSettlementAvailable
      ? payload.cashAmount
      : totals.totalCashAmount,
    total: isSettlementAvailable ? payload.total : totals.totalCashAmount,
    totalDiscountNotes: parseFloat(totalDiscountNotes.toFixed(2)),
    isDeleteNotes: payload.notes.length > 0,
  };

  return {
    ...state,
    settlementLoading: false,
    settlement: newPayload,
    blackListFolio,
  };
};

export const editSettlementNote = (state, payload) => {
  const { account, note } = payload;
  const { alias, customer, code, id: accountId } = account;
  const noteState = state.settlement.notes.find(
    (note) => note.id === payload.note.id,
  );
  const { tax, folio, date, type, total, details } = note;

  const newCustomer = {
    id: customer.id,
    name: customer.name,
    code: customer.code,
    isCredit: customer.isCredit,
    credit: customer.credit,
    creditSuspended: customer.creditSuspended,
    discount: customer.discount,
    account: {
      id: accountId,
      name: alias,
      code: code,
    },
  };

  const newNote = {
    id: noteState.id,
    tax,
    folio,
    date,
    type,
    total,
    customer: newCustomer,
    details,
  };

  let cashAmount = 0;
  let creditAmount = 0;

  const newNotes = state.settlement.notes.map((note) => {
    let actualNote = note;
    if (note.id === payload.note.id) actualNote = newNote;

    if (actualNote?.type === "CREDITO") creditAmount += actualNote.total;
    else cashAmount += actualNote.total;

    return actualNote;
  });

  return {
    ...state,
    noteSelected: newNote,
    settlement: {
      ...state.settlement,
      cashAmount,
      creditAmount,
      total: cashAmount + creditAmount,
      notes: processNotes(newNotes),
    },
  };
};

export const changeSettlementStartRouteEndowments = (state, payload) => {
  if (payload.value < 0) return state;
  let startInsert = {
    ...state.settlement.routes.start,
    endowments: {
      ...state.settlement.routes.start.endowments,
      [payload.key]: payload.value,
    },
  };

  const start10 =
    (Number(startInsert.endowments.cil10) -
      Number(state.settlement.routes.end.endowments.cil10)) *
    10;
  const start20 =
    (Number(startInsert.endowments.cil20) -
      Number(state.settlement.routes.end.endowments.cil20)) *
    20;
  const start30 =
    (Number(startInsert.endowments.cil30) -
      Number(state.settlement.routes.end.endowments.cil30)) *
    30;
  const start45 =
    (Number(startInsert.endowments.cil45) -
      Number(state.settlement.routes.end.endowments.cil45)) *
    45;
  const resultStart =
    start10 + start20 + start30 + start45 + state.settlement.kgBulk || 0;
  return {
    ...state,
    settlement: {
      ...state.settlement,
      routes: {
        ...state.settlement.routes,
        start: startInsert,
      },
      totalReport: parseFloat(resultStart.toFixed(2)),
    },
  };
};

export const changeSettlementEndRouteEndowments = (state, payload) => {
  if (payload.value < 0) return state;
  let endInsert = {};
  let resultEnd = 0;
  let end10 = 0,
    end20 = 0,
    end30 = 0,
    end45 = 0;

  if (!payload.isBulk) {
    endInsert = {
      ...state.settlement.routes.end,
      endowments: {
        ...state.settlement.routes.end.endowments,
        [payload.key]: payload.value,
      },
    };
    end10 =
      (Number(state.settlement.routes.start.endowments.cil10) -
        Number(endInsert.endowments.cil10)) *
      10;
    end20 =
      (Number(state.settlement.routes.start.endowments.cil20) -
        Number(endInsert.endowments.cil20)) *
      20;
    end30 =
      (Number(state.settlement.routes.start.endowments.cil30) -
        Number(endInsert.endowments.cil30)) *
      30;
    end45 =
      (Number(state.settlement.routes.start.endowments.cil45) -
        Number(endInsert.endowments.cil45)) *
      45;
    resultEnd = end10 + end20 + end30 + end45 + state.settlement.kgBulk || 0;
  } else {
    end10 =
      (Number(state.settlement.routes.start.endowments.cil10) -
        Number(state.settlement.routes.end.endowments.cil10)) *
      10;
    end20 =
      (Number(state.settlement.routes.start.endowments.cil20) -
        Number(state.settlement.routes.end.endowments.cil20)) *
      20;
    end30 =
      (Number(state.settlement.routes.start.endowments.cil30) -
        Number(state.settlement.routes.end.endowments.cil30)) *
      30;
    end45 =
      (Number(state.settlement.routes.start.endowments.cil45) -
        Number(state.settlement.routes.end.endowments.cil45)) *
      45;
    resultEnd = end10 + end20 + end30 + end45 + payload.value || 0;
  }
  return {
    ...state,
    settlement: {
      ...state.settlement,
      routes: {
        ...state.settlement.routes,
        end: payload.isBulk ? state.settlement.routes.end : endInsert,
      },
      totalReport: parseFloat(resultEnd.toFixed(2)) || 0,
      kgBulk: payload.isBulk ? payload.value : state.settlement.kgBulk,
    },
  };
};

export const addSettlementNewNote = (state, payload) => {
  let addNotes = state.settlement?.notes || [];
  const unitType = state.settlement?.unit?.priceType === "PORTATIL";
  let newTotalKilosSold = 0;
  let newTotalLitersSold = 0;
  let isMultiProductAdd = false;
  const idx = addNotes.findIndex((note) => note.id === payload.id);

  if (payload.editNote) {
    addNotes[idx] = { ...addNotes[idx], ...payload };
  } else {
    addNotes = [...addNotes, payload];
  }

  let removeElements = [];
  let newAddNotes = [];
  if (unitType) {
    //
    newAddNotes = addNotes.map((note, idx) => {
      const types = note.details.map((detail) => detail.name);
      removeElements = [...new Set(types)];
      isMultiProductAdd = removeElements.length > 1;
      if (!note.deleted) {
        newTotalKilosSold += note.details.reduce(
          (acc, curr) =>
            acc + parseFloat(curr.capacity) * parseFloat(curr.quantity),
          0,
        );
        newTotalLitersSold += note.details.reduce(
          (acc, curr) =>
            acc + (parseFloat(curr.capacity) * parseFloat(curr.quantity)) / FM,
          0,
        );
      }

      return {
        ...note,
        name: isMultiProductAdd ? "MULTI-PRODUCTO" : removeElements[0],
        position: idx + 1,
      };
    });
    //
  } else {
    newAddNotes = addNotes.map((note, idx) => {
      const types = note.details.map((detail) => detail.name);
      removeElements = [...new Set(types)];
      isMultiProductAdd = removeElements.length > 1;

      if (!note.deleted) {
        newTotalKilosSold += note.details.reduce(
          (acc, curr) =>
            acc + parseFloat(curr.capacity) * parseFloat(curr.quantity) * FM,
          0,
        );
        newTotalLitersSold += note.details.reduce(
          (acc, curr) =>
            acc + parseFloat(curr.capacity) * parseFloat(curr.quantity),
          0,
        );
      }

      return {
        ...note,
        name: isMultiProductAdd ? "MULTI-PRODUCTO" : removeElements[0],
        position: idx + 1,
      };
    });
  }

  const nTotals = addNotes
    .filter((nt) => !nt.deleted)
    .reduce(
      (acc, curr) => {
        const payment = state.payments.find((py) => py.id === curr.idPayment);
        const paymentType = payment?.method?.toLowerCase();

        if (paymentType === "credito") {
          acc.totalCreditAmount += curr.total;
        } else if (paymentType === "contado") {
          acc.totalCashAmount += curr.total;
        }

        return acc;
      },
      {
        totalCreditAmount: 0,
        totalCashAmount: 0,
      },
    );

  const noteDiscount = addNotes.reduce((a, c) => a + c.discount, 0);

  return {
    ...state,
    settlement: {
      ...state.settlement,
      routes: {
        ...state.settlement.routes,
        end: {
          ...state.settlement.routes.end,
        },
      },
      notes: newAddNotes,
      totalKilosSold: newTotalKilosSold,
      totalLitersSold: newTotalLitersSold,
      total: nTotals.totalCashAmount,
      totalDiscountNotes: noteDiscount,
      creditAmount: nTotals.totalCreditAmount,
      cashAmount: nTotals.totalCashAmount,
    },
  };
};

export const removeSettlementNote = (state, payload) => {
  const unitTypeD = state.settlement?.unit?.priceType === "PORTATIL";
  const removeItem = state.settlement.notes.map((nt) =>
    nt.id !== payload.noteId
      ? nt
      : {
          ...nt,
          deleted: true,
          deletedCauseId: payload?.causeId ? payload?.causeId : null,
          skip: payload?.causeId ? false : true,
        },
  );

  const {
    totalCashAmount,
    totalCreditAmount,
    totalKilosSold,
    totalLitersSold,
  } = removeItem
    .filter((rm) => !rm.deleted)
    .reduce(
      (acc, curr) => {
        const payment = state.payments.find((py) => py.id === curr.idPayment);
        const paymentType = payment?.method?.toLowerCase();

        if (paymentType === "credito") {
          acc.totalCreditAmount += curr.total;
        } else if (paymentType === "contado") {
          acc.totalCashAmount += curr.total;
        }
        curr.details.forEach((detail) => {
          const capacity = parseFloat(detail.capacity);
          const quantity = parseFloat(detail.quantity);

          if (unitTypeD) {
            acc.totalKilosSold += capacity * quantity;
            acc.totalLitersSold += (capacity * quantity) / FM;
          } else {
            acc.totalKilosSold += capacity * quantity * FM;
            acc.totalLitersSold += capacity * quantity;
          }
        });

        return acc;
      },
      {
        totalCashAmount: 0,
        totalCreditAmount: 0,
        totalKilosSold: 0,
        totalLitersSold: 0,
      },
    );
  return {
    ...state,
    settlement: {
      ...state.settlement,
      routes: {
        ...state.settlement.routes,
        end: {
          ...state.settlement.routes.end,
        },
      },
      notes: removeItem,
      totalKilosSold,
      totalLitersSold,
      total: totalCashAmount,
      cashAmount: totalCashAmount,
      creditAmount: totalCreditAmount,
    },
  };
};
